import TerminationActionTypes from './termination.types';

const INITIAL_STATE = {
  data: null,
  error: null,

  suspendAzure: false,
  forwardingEmail: '',
  termEmail: '',
  termDepartment: '',
  termPosition: '',
  termNoc: null,
  termNavitaire: null,
  termLocation: '',
  termUber: null,
  termLyft: null,
};

const terminationreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TerminationActionTypes.GET_TERM_DATA_SUCCESS:
      return { ...state, error: null, data: action.payload };

    case TerminationActionTypes.GET_TERM_DATA_FAILURE:
      return { ...state, error: action.payload, data: null };

    case TerminationActionTypes.SET_TERM_DEPARTMENT:
      return { ...state, termDepartment: action.payload };

    case TerminationActionTypes.SET_TERM_POSITION:
      return { ...state, termPosition: action.payload };

    case TerminationActionTypes.SET_TERM_NOC:
      return { ...state, termNoc: action.payload };

    case TerminationActionTypes.SET_TERM_NAVITAIRE:
      return { ...state, termNavitaire: action.payload };

    case TerminationActionTypes.SET_TERM_EMAIL:
      return { ...state, termEmail: action.payload };

    case TerminationActionTypes.SET_FORWARDING_EMAIL:
      return { ...state, forwardingEmail: action.payload };

    case TerminationActionTypes.SET_TERM_LOCATION:
      return { ...state, termLocation: action.payload };

    case TerminationActionTypes.SET_TERM_UBER:
      return { ...state, termUber: action.payload };

    case TerminationActionTypes.SET_TERM_LYFT:
      return { ...state, termLyft: action.payload };

    case TerminationActionTypes.SET_SUSPEND_AZURE:
      return { ...state, suspendAzure: action.payload };

    default:
      return state;
  }
};

export default terminationreducer;
